const ja = {
  entry: {
    default: "このサイトはデフォルトのチェックアウトを使用しています",
    configured: "この Web サイトはカスタム チェックアウトを構成しています",
    edit: "チェックアウトスタイルを編集する",
    copy: "チェックアウトスタイルをコピーする",
    copyWhat: "現在の Web サイトのチェックアウトをどの Web サイトにコピーしますか?コピーされたチェックアウトは確認後に有効になります。",
    webSite: "Webサイト"
  },
  settings: {
    title: "カスタマイズされたチェックアウトデスク",
    reset: "デフォルトのスタイルを復元する",
    save: "保存して有効にする",
    tip: "特定の定義済みスタイルを使用して、チェックアウトを Web サイトでより適切に見栄えよくします。",
    tabInfo: "ブラウザタグアイテム情報",
    tabTitle: "タブのタイトル",
    browserTabIconUrl: "タブアイコン",
    brand: "ブランド",
    themeType: "外観スタイル",
    layoutType: "ページレイアウト",
    layoutStyle: "支払い方法の表示レイアウト",
    tab: "従来のレイアウト (左右のタブ)",
    accordion: "縦型レイアウト",
    text: "文章",
    light: "明るい色",
    dark: "暗い",
    headerBg: "タイトルバーの背景色",
    cashierLogo: "ブランドロゴ",
    cashierLogoPosition: "ロゴの場所",
    headerText: "タイトルブロックのコピー",
    themeColor: "ブランドのアクセントカラー",
    languages: "サポートされている言語",
    langTips: "右側のプレビューには英語が表示されますが、実際の選択内容は選択内容によって異なります。",
    all: "すべて選択",
    formStyle: "フォームスタイル",
    prompt: "プロンプト",
    font: "フォント",
    default: "デフォルト",
    shape: "コンポーネントの形状",
    round: "フィレットサイズ",
    size: "コンポーネントのサイズ",
    spacing: "コンポーネントの間隔",
    fontSize: "フォントサイズ",
    showReturn: "返却口を見せる",
    showCardsLogo: "カードのブランドロゴ",
    returnText: "コピーに戻る",
    returnPosition: '位置',
    showPCI: "安全保証を表示",
    roundedRectangle: "角丸長方形",
    squareRectangle: "角が四角い長方形",
    fullyRounded: "完全に丸い角",
    small: "小型",
    medium: "中型サイズ",
    large: "大きいサイズ",
    left: "左揃え",
    center: "中心",
    right: "右揃え",
    orderInfo: "注文情報表示",
    showOrderId: "注文IDを表示",
    showOrderAmount: "注文金額を表示",
    showBilling: "請求先住所を表示する",
    resultPage: "結果プロンプトページ",
    toPingPongResult: "PingPongが提供する「決済完了ページ」を表示する",
    resultAutoRedirect: "「決済完了ページ」表示後、自動でジャンプします",
    resultAutoRedirectTime: "「決済完了ページ」滞在時間（デフォルトは3秒）",
    preview: "プレビュー",
    redirect: "チェックアウトにジャンプ",
    embed: "内蔵レジ",
    embedTip: "ヒント: 埋め込みキャッシャーには構成コンテンツの一部のみが含まれます",
    embedLangTip: "ヒント: 埋め込みチェックアウト言語は Web ページに従っており、デフォルトは英語です。",
    mobileTip: "ヒント: モバイル チェックアウトには構成コンテンツの一部のみが含まれます",
    cancelEdit: "変更を破棄することを確認しますか?",
    confirmLeave: "変更内容はまだ保存されていません。ページを離れてもよろしいですか?ページを離れると、変更されたコンテンツが失われます。",
    confirmLeave2: "このページを離れてもよろしいですか?",
    saveSuccess: "正常に保存されました",
    saveFailed: "保存に失敗しました。もう一度お試しください",
    confirmDefault: "デフォルト設定を復元してもよろしいですか?",
    tips: "ヒント",
    notSupport: "Shopify や Shopline などの Web サイト構築プラットフォームの組み込みチェックアウトは、この機能をサポートしていません。"
  },
  upload: {
    imageSize: "画像サイズ",
    recommendFormat: "推奨フォーマット",
    fileSize: "ファイルサイズ",
    uploadFailed: "アップロードに失敗しました",
    formatError: "画像フォーマットエラー",
    formatTip: "画像は JPG、JPEG、PNG、BMP、SVG、ICO 形式である必要があります",
    attention: "確認",
    uploadTip: "10KB以下",
    uploadTip2: "32×32ピクセル",
    sizeError: "画像サイズが間違っています",
    sizeTip: "画像サイズは{size}ピクセルでなければなりません",
    failed: "失敗",
    loadFailed: "画像を読み込めません。もう一度お試しください。",
    readField: "ファイルを読み取れません。もう一度お試しください。",
    clear: "クリア"
  },
  button: {
    continue: "編集を続ける",
    discard: "変更を破棄する",
    confirm: "確認",
    cancel: "キャンセル"
  }
};
export default ja;